import Page from "@/lib/components/Page";
import Center from "@/lib/components/Center";
import NavButton from "@/lib/components/NavButton";
import Header from "@/lib/components/Header";

export default function NotFoundScreen() {
    return (
        <Page>
            <Center>
                <Header title={"Finner ikke siden"} center={true}/>
                <NavButton title={"Start på nytt"} href={`/`}/>
            </Center>
        </Page>
    )
}